import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { IConnectContact, IConnectRoom } from '../models';
import { CONNECT_API_URL_TOKEN } from '../tokens';

@Injectable()
export class ConnectService {
  constructor(
    @Inject(CONNECT_API_URL_TOKEN) public connectApiUrl: string,
    private http: HttpClient,
  ) {}

  public acquireConnectToken(): Observable<string> {
    return this.http.post(`${this.connectApiUrl}/login`, null, {
      responseType: 'text',
    });
  }

  public loadUserContacts(): Observable<IConnectContact[]> {
    return this.http.get<IConnectContact[]>(`${this.connectApiUrl}/users`);
  }

  public loadRoom() {
    return this.http.post<IConnectRoom>(
      `${this.connectApiUrl}/video/room`,
      null,
    );
  }

  public acquireTwilioToken() {
    return this.http.get(`${this.connectApiUrl}/video/token`, {
      responseType: 'text',
    });
  }
}
